import {Injectable, Optional} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {FUIStackedPageContextService} from "@fedeltapointofsale/ui";
import {firstValueFrom, map} from "rxjs";

@Injectable()
export class PageParameterService {

    static encodeParams(item: any): string {
        return btoa(JSON.stringify(item));
    }

    static decodeParams(value: string): any {
        return JSON.parse(atob(value));
    }

    constructor(private route: ActivatedRoute, @Optional() private stackedPageContextService: FUIStackedPageContextService) {
    }

    async getParams(paramName: string = "params"): Promise<any> {
        return this.stackedPageContextService ? this.stackedPageContextService.params : firstValueFrom(this.route.queryParams.pipe(
            map((params => params[paramName] ? PageParameterService.decodeParams(params[paramName]) : undefined))
        ));
    }
}
